import { useTranslation } from 'react-i18next';
import { Link } from 'react-router';
import type { SortOption } from 'types/capi/plp';

import SortIcon from '~/assets/icons/Sort';
import useSortInteraction from '~/hooks/useSortInteraction';

import Dropdown, { DropdownOption } from './Dropdown';

type Props = {
  options: SortOption[];
};

const SORT_LABEL_KEYS = {
  LATEST_RELEASES: 'sortLatestReleases',
  POPULAR: 'sortWhatsHot'
} as const;

const SortOptions = ({ options }: Props) => {
  const { t } = useTranslation(['plp', 'common']);
  const fireSortInteraction = useSortInteraction();

  function labelFor(option: SortOption) {
    const labelKey =
      option.sort_key &&
      SORT_LABEL_KEYS[option.sort_key as keyof typeof SORT_LABEL_KEYS];

    return labelKey ? t(labelKey) : option.text;
  }

  const activeOption = options.find((option) => option.active);

  return (
    <Dropdown
      className="z-10 w-fit max-w-lg"
      name="sort"
      selectedValue={activeOption?.text}
      trigger={
        <>
          <SortIcon height="16" width="16" />
          {activeOption
            ? labelFor(activeOption)
            : t('sortBy', { ns: 'common' })}
        </>
      }
      triggerClassName="flex items-center gap-2 text-sm"
    >
      {(close) =>
        options.map((option) => (
          <DropdownOption
            isSelected={Boolean(option.active)}
            key={option.text}
            name="sort"
            onClick={() => {
              close();

              const sortKey = option.sort_key ?? option.key;

              if (sortKey) fireSortInteraction(sortKey, 'sort_menu');
            }}
            render={<Link to={option.path} rel="nofollow" />}
            value={option.text}
          >
            {labelFor(option)}
          </DropdownOption>
        ))
      }
    </Dropdown>
  );
};

export default SortOptions;
